import { render, staticRenderFns } from "./create-secondhand.vue?vue&type=template&id=196b6857&scoped=true&"
import script from "./create-secondhand.vue?vue&type=script&lang=ts&"
export * from "./create-secondhand.vue?vue&type=script&lang=ts&"
import style0 from "./create-secondhand.vue?vue&type=style&index=0&id=196b6857&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b6857",
  null
  
)

component.options.__file = "create-secondhand.vue"
export default component.exports